/* lkp2-18.js - audit fixes part 2 (19/10/2026), loads after lkp2-17.js and only wraps P.prototype methods:
   tie clip handwriting at the far right end, previews keep the whole piece in view, pen barrel framing,
   blank option hides the sides option, tidy "Already in your basket" box, two-tone swatch, plain confirm tick box. */
(function () {
  'use strict';
  var K = window.__lkp2k, P = K && K.P;
  if (!P || !P.prototype._lkAudit || P.prototype._lkAudit2) return;
  P.prototype._lkAudit2 = 1;
  var lc = K.lc;

  /* ---------- tie clips: handwriting / uploads sit at the far right end too (like text) ---------- */
  var oPlan2 = P.prototype.plan;
  P.prototype.plan = function (f, ph) {
    var r = oPlan2.apply(this, arguments);
    if (r && r.z && ph && ph.isArt && /^tie-clip/.test(ph.art || '')) {
      var uw = r.z.w * 0.94;
      (r.ops || []).forEach(function (o) {
        if ((o.k === 'img' || o.k === 'ph') && Math.abs(o.x || 0) < 1 && o.w > uw * 0.7) { o.w = uw * 0.6; o.x = uw / 2 - o.w / 2; }
      });
    }
    return r;
  };

  /* ---------- previews keep the whole piece in view (charm, shackle, keyring ends) ---------- */
  var oBase2 = P.prototype.base;
  P.prototype.base = function (ph) {
    var me = this, p = oBase2.apply(this, arguments);
    if (ph && ph.isArt && p && p.then) p.then(function (c) { (me._lkCv || (me._lkCv = {}))[ph.src] = c; }, function () {});
    return p;
  };
  P.prototype.lkBox = function (ph, W, H) {
    var c = this._lkCv && this._lkCv[ph.src]; if (!c || c.width !== W) return null;
    var z = ph.zone, key = ph.src + '|' + z.x + ',' + z.y + ',' + z.w + ',' + z.h, C = this._lkBB || (this._lkBB = {});
    if (C[key] !== undefined) return C[key];
    var res = null, ctx = c.getContext('2d', { willReadFrequently: true });
    var scan = function (x0, y0, x1, y1) {
      x0 = Math.max(0, Math.floor(x0)); y0 = Math.max(0, Math.floor(y0)); x1 = Math.min(W, Math.ceil(x1)); y1 = Math.min(H, Math.ceil(y1));
      var d = ctx.getImageData(x0, y0, x1 - x0, y1 - y0).data, w = x1 - x0, hh = y1 - y0;
      var bx0 = 1e9, by0 = 1e9, bx1 = -1, by1 = -1, step = Math.max(2, Math.round(W / 400));
      for (var y = 0; y < hh; y += step) for (var x = 0; x < w; x += step) {
        var i = (y * w + x) * 4; if (d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114 > 228) continue;
        if (x < bx0) bx0 = x; if (x > bx1) bx1 = x; if (y < by0) by0 = y; if (y > by1) by1 = y;
      }
      return bx1 > bx0 && by1 > by0 ? { x0: x0, y0: y0, x1: x1, y1: y1, b: { x: x0 + bx0, y: y0 + by0, w: bx1 - bx0, h: by1 - by0 }, e: Math.max(step * 2, 4) } : null;
    };
    try {
      /* start around the zone; grow towards any side the piece still touches (shackle, keyring end) */
      var X0 = (z.x - z.w * 1.6) / 100 * W, X1 = (z.x + z.w * 1.6) / 100 * W, Y0 = (z.y - z.h) / 100 * H, Y1 = (z.y + z.h) / 100 * H, sc = null;
      for (var k = 0; k < 4; k++) {
        sc = scan(X0, Y0, X1, Y1); if (!sc) break;
        var bb = sc.b, grow = false, gx = z.w / 100 * W * 0.8, gy = z.h / 100 * H;
        if (bb.y - sc.y0 < sc.e && sc.y0 > 0) { Y0 -= gy; grow = true; }
        if (sc.y1 - (bb.y + bb.h) < sc.e && sc.y1 < H) { Y1 += gy; grow = true; }
        if (bb.x - sc.x0 < sc.e && sc.x0 > 0) { X0 -= gx; grow = true; }
        if (sc.x1 - (bb.x + bb.w) < sc.e && sc.x1 < W) { X1 += gx; grow = true; }
        if (!grow) break;
      }
      if (sc) res = sc.b;
    } catch (e) { res = null; }
    /* the engraving / charm zone itself always counts (a charm drawn live is not in the photo) */
    var zx0 = (z.x - z.w / 2) / 100 * W, zy0 = (z.y - z.h / 2) / 100 * H, zx1 = (z.x + z.w / 2) / 100 * W, zy1 = (z.y + z.h / 2) / 100 * H;
    if (res) { var ax0 = Math.min(res.x, zx0), ay0 = Math.min(res.y, zy0), ax1 = Math.max(res.x + res.w, zx1), ay1 = Math.max(res.y + res.h, zy1); res = { x: ax0, y: ay0, w: ax1 - ax0, h: ay1 - ay0 }; }
    C[key] = res; return res;
  };
  var oVR = P.prototype.viewRect;
  P.prototype.viewRect = function (ph, W, H, A, mode) {
    var r = oVR.apply(this, arguments);
    if (mode === 'full' || mode === 'close' || !ph || !ph.isArt || ph.whole || ph.pens) return r;
    var b = this.lkBox(ph, W, H); if (!b) return r;
    var pad = Math.max(b.w, b.h) * 0.05, bx0 = b.x - pad, by0 = b.y - pad, bx1 = b.x + b.w + pad, by1 = b.y + b.h + pad;
    if (bx0 >= r.x && by0 >= r.y && bx1 <= r.x + r.w && by1 <= r.y + r.h) return r;
    /* the piece itself decides: centre on it, fit it, never zoom out more than 2x */
    var cx = (bx0 + bx1) / 2, cy = (by0 + by1) / 2, sw = Math.max(bx1 - bx0, (by1 - by0) * A), cap = r.w * 2;
    sw = Math.min(Math.max(sw, r.w), cap); var sh = sw / A;
    if (by1 - by0 > sh) cy = by1 - sh / 2; /* too tall to fit: keep the bottom of the piece (hanging charm, lock body) */
    var zx0 = (ph.zone.x - ph.zone.w / 2) / 100 * W, zx1 = (ph.zone.x + ph.zone.w / 2) / 100 * W, zy0 = (ph.zone.y - ph.zone.h / 2) / 100 * H, zy1 = (ph.zone.y + ph.zone.h / 2) / 100 * H, zp = 0.04 * sw;
    if (sw > zx1 - zx0 + 2 * zp) cx = Math.min(Math.max(cx, zx1 + zp - sw / 2), zx0 - zp + sw / 2);
    if (sh > zy1 - zy0 + 2 * zp) cy = Math.min(Math.max(cy, zy1 + zp - sh / 2), zy0 - zp + sh / 2);
    return { x: Math.min(Math.max(cx - sw / 2, Math.min(0, W - sw)), Math.max(0, W - sw)), y: Math.min(Math.max(cy - sh / 2, Math.min(0, H - sh)), Math.max(0, H - sh)), w: sw, h: sh };
  };

  /* ---------- Parker pen: tinted photos framed so the coloured barrel shows ---------- */
  var oPL2 = P.prototype.photoList;
  P.prototype.photoList = function () {
    var l = oPL2.apply(this, arguments);
    (l || []).forEach(function (ph) { if (ph && ph.tint) ph.view = { x: 45, y: 52, zoom: 1.3 }; });
    return l;
  };

  /* ---------- blank: the sides option means nothing without engraving; no stale side name ---------- */
  var oSync3 = P.prototype.sync;
  P.prototype.sync = function () {
    var r = oSync3.apply(this, arguments);
    if (this.elXo) {
      var cnt = this.optName && this.optName('count'), ci = cnt != null && this.optIndex ? this.optIndex[lc(cnt)] : null;
      var blank = !this.choices && !this.st.engrave;
      if (ci != null) { var g = this.elXo.querySelector('[data-xo="' + ci + '"]'); if (g && !this.lkSides()) g.classList.toggle('lk-xo-off', blank); }
    }
    if (!this.faces().length) { var fn = this.root.querySelector('[data-facename]'); if (fn) fn.textContent = ''; }
    return r;
  };

  /* ---------- "Already in your basket" box: short and consistent with the cart ---------- */
  var oRCB = P.prototype.renderCartBox;
  if (oRCB) P.prototype.renderCartBox = function () {
    var r = oRCB.apply(this, arguments), hb = this.host || this.root, box = hb && hb.querySelector('[data-incart]');
    if (box && !box.hidden) {
      var sp = box.querySelector('p b + span'); if (sp) sp.remove();
      var mu = box.querySelector('.lkp2__muted');
      if (mu) mu.textContent = mu.textContent.split(' · ').filter(function (x) { return !/ - type: /.test(x); }).map(function (x) { return x.replace(/Font \d+ - /g, ''); }).join(' · ');
    }
    return r;
  };

  /* Review on a blank item: no "Sides engraved" row */
  var oSum3 = P.prototype.renderSummary;
  P.prototype.renderSummary = function () {
    var r = oSum3.apply(this, arguments);
    if (this.elSummary && !this.choices && !this.st.engrave) {
      var cnt = this.optName && this.optName('count');
      if (cnt) this.elSummary.querySelectorAll('li.lk-rv').forEach(function (li) { var a = li.querySelector('.lkp2__sface'); if (a && lc(a.textContent) === lc(cnt)) li.remove(); });
    }
    return r;
  };

  var css2 = document.createElement('style');
  css2.textContent = [
    '.lkp2 .lkp2__sw.lk-two[data-col] i{background:linear-gradient(90deg,#eef0f2 0%,#c3c8ce 50%,#ecc96f 50%,#c69c3e 100%)!important}',
    '.lkp2--modal .lkp2__swatches{gap:14px 12px!important;align-items:flex-start}',
    '.lk-swl{width:58px;margin-left:-7px;white-space:normal!important;font-size:10.5px!important}',
    '.lkp2 .lkp2__confirm{background:#fff!important;color:#1b1c1e!important;border:1px solid #cfc6ba!important;border-radius:10px!important;text-transform:none!important;font-weight:500!important;letter-spacing:0!important;font-size:14px!important;min-height:48px;display:flex!important;align-items:center;gap:10px;padding:8px 12px!important;line-height:1.35;cursor:pointer}',
    '.lkp2 .lkp2__confirm input{width:22px;height:22px;flex:0 0 22px;accent-color:#2a3548}'
  ].join('');
  document.head.appendChild(css2);

  function redraw() { document.querySelectorAll('[data-lkp2]').forEach(function (el) { var m = el.__lkp2; if (m && m.cfg && !m._lkR18) { m._lkR18 = 1; try { m._sig = null; m.sync(); } catch (e) {} } }); }
  redraw(); setTimeout(redraw, 1600);
})();
